export default __webpack_public_path__ + "static/media/gallery_05.defbbb97.jpg";